import React from 'react';
// import User from './img/author.svg';
import {parseISO,format}  from 'date-fns';
import "./Comments.scss"

const Comment = (props) => {
  const {comment} = props;
  const {dateCreated, commentText, userFirstName, imageUrl, userLastName} = comment;
  // const {firstName, lastName} = user;
  const makeInitials = () => {
    const initials = [];
    if (userFirstName) initials[0] = userFirstName[0];
    // if (?.userFirstName) initials[0] = userFirstName[0];
    if (userLastName) initials[1] = userLastName[0];
    // if (user?.userLastName) initials[1] = userLastName[0];
    return initials.join('');
}; 
const avatar = imageUrl ? (
  <img src={imageUrl} alt="Avatar"/>
) : (
  `${makeInitials()}`
);


  return (
    <div className="document-comment">
      <div className="document-comment__image">
      <div className="avatar-pic avatar-user">
         {avatar}
         </div>
      </div>
      <div className="document-comment__data">
        <div className="document-comment__info">
          <p className="document-comment__author">
            {userFirstName + ' ' + userLastName}
            {/* {userLogin} */}
          </p>
          <p className="document-comment__date">
    
           {format(parseISO(dateCreated), 'dd.MM.yyyy. | HH:mm')}
          </p>
        </div>
        <div className="document-comment__text">
          <p>{commentText}</p>
        </div>
      </div>
    </div>
  );
};

export default Comment;
